// This file was generated on Mon, Jan  7, 2019  2:39:54 PM
export const appVersion = '0.3.3';
export const appDate = 'Mon, Jan  7, 2019  2:39:54 PM';
